import React, { useEffect, useState, useMemo } from 'react';
import TableFixedPage from '../../TableFixedPage/TableFixedPage';
import { Select } from "antd";
import PayedReqTabel from '../../Tables/PayReq/PayedReqTabel/PayedReqTabel';
import moment from 'moment-jalaali';
import { separate } from './../../../Utils/SeprateNumber/SeprateThreeNumber';
import { GetPayedWithdrawListAPI } from '../../../Api/PanelAdminServices';
import { errorToast } from '../../../Utils/Toast/Toast';

const PayedRequestContainer = () => {
    const [withdrawListState, setWithdrawListState] = useState([]);
    const [userTypeState, setUserTypeState] = useState("supplier");

    useEffect(() => {
        WithdrawList();
    }, []);

    const WithdrawList = async () => {
        GetPayedWithdrawListAPI((succ, res) => {
            if (succ) {
                if (res.status === 0) {
                    errorToast("مشکلی پیش آمده است");
                } else {
                    setWithdrawListState(res.withdraw);
                }
            } else {
                errorToast("خطایی در سرور رخ داده است");
            }
        });
    };

    const Supplierdata = useMemo(() => {
        const list =
            userTypeState === 'supplier'
                ? withdrawListState?.supplier
                : userTypeState === 'deliver'
                ? withdrawListState?.deliver
                : withdrawListState?.user;

        return list?.map((item) => ({
            key: item.id,
            name: `${item.first_name} ${item.last_name}`,
            phone: item.phone,
            date: moment.unix(parseInt(item.date)).format("jYYYY/jM/jD----hh:mm:ss a"),
            money: `${separate((item.amount * -1) - (item.wage * -1))} تومان`,
            track_id: item.track_id,
            withdraw_date: moment.unix(parseInt(item.withdraw_date)).format("jYYYY/jM/jD----hh:mm:ss a"),
        }));
    }, [userTypeState, withdrawListState]);

    const SupplierdataNew = useMemo(() => {
        return Supplierdata
            ?.filter(item => item.track_id !== null)
            .sort((a, b) => b.key - a.key);
    }, [Supplierdata]);

    return (
        <section className="w-100 d-flex align-items-center flex-column">
            <TableFixedPage title={"بایگانی پرداختی ها"} />
            <Select
                defaultValue={'supplier'}
                className="w-75 my-3"
                style={{ width: 120 }}
                onChange={setUserTypeState}
                value={userTypeState}
                options={[
                    { value: "user", label: "مشتری" },
                    { value: "deliver", label: "پیک یا راننده" },
                    { value: "supplier", label: "تامین کننده" },
                ]}
            />
            <PayedReqTabel data={SupplierdataNew} />
        </section>
    );
};

export default PayedRequestContainer;
